import React from 'react'

// apollo
import { ApolloProvider } from '@apollo/client'
import { client } from 'lib/apollo'

// redux
import { Provider as ReduxProvider } from 'react-redux'
import store from 'lib/stores/account/redux'

import AppErrorBoundary from 'components/shared/AppErrorBoundary'
import BrandTheme from 'components/shared/BrandTheme'
import SettingsProvider from 'components/shared/SettingsProvider'

// routes
import Routes from './Routes'
import CssBaseline from '@mui/material/CssBaseline'

// date picker
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

const App = ({ basename, appSettings, brandSettings }) => (
  <SettingsProvider appSettings={appSettings} brandSettings={brandSettings}>
    <ReduxProvider store={store}>
      <ApolloProvider client={client}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <BrandTheme brandSettings={brandSettings}>
            <CssBaseline />
            <AppErrorBoundary>
              <Routes basename={basename} />
            </AppErrorBoundary>
          </BrandTheme>
        </LocalizationProvider>
      </ApolloProvider>
    </ReduxProvider>
  </SettingsProvider>
)

export default App
